
import React from "react";

import { Box, Button, IconButton, Typography, Fab, Tooltip, Slide } from "@mui/material";

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import useNotification from '../../../../Notification';
import api from '../../../../../api';

import "./styles.css";

const MEDIA_SETTINGS = {
    'image': {
        'translation': 'imagem',
        'max_size': '5MB',
        'max_bytes': 5242880
    },
    'video': {
        'translation': 'vídeo',
        'max_size': '16MB',
        'max_bytes': 16777216
    },
    'document': {
        'translation': 'documento',
        'max_size': '100MB',
        'max_bytes': 104857600
    }
}

const inferFileType = (mimeType) => {
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType.startsWith('video/')) return 'video';
    return 'document';
}

class AttachmentArea extends React.Component {

    isFileValid = (fileObj) => {
        return fileObj.file.size <= MEDIA_SETTINGS[fileObj.type].max_bytes;
    }

    canSubmit = () => {
        return this.props.files.length > 0 && this.props.files.every(this.isFileValid);
    }

    //Deprecated
    hasWhatsappBlock = () => {
        return false
    }

    handleAddMore = (e) => {
        const newFiles = Array.from(e.target.files).map((file) => ({
            id: crypto.randomUUID(),
            name: file.name,
            preview: URL.createObjectURL(file),
            file: file,
            type: inferFileType(file.type)
        }));

        e.target.value = '';

        if (newFiles.length > 0)
            this.props.addFiles(newFiles);
    }

    isSupervised = (queue) => {
        return 'settings' in this.props.activeChat.queue
            && this.props.activeChat.queue.settings
            && 'media_supervision' in this.props.activeChat.queue.settings
            && this.props.activeChat.queue.settings.media_supervision;
    }

    sendSingleFile = async (fileObj) => {
        const file = new File([fileObj.file], fileObj.name);

        const chat = this.props.chat
        const queue_name = chat.queues_name ? chat.queues_name : chat.queue.name
        const channel = chat.channel ? chat.channel : chat.hash
        const connection = this.props.connections?.find(con => con.queue == queue_name)

        const formData = new FormData();
        formData.append('media', file);
        formData.append('chat_hash', this.props.activeChat.channel);
        formData.append('queue_id', this.props.activeChat.queue.id);

        let newMessage = {
            "id": 0,
            "message": 'Enviando Mídia',
            "iso_time": "--:--",
            "msg": 'SENDINGMEDIAMESSAGE',
        }

        this.props.addMessage(newMessage)

        try {
            const res = await api.post('/api/whatsapp/media/', formData, { timeout: 0 })

            if (res.status !== 200) {
                newMessage.id = -2
                newMessage.expired = true
                newMessage.message = 'Enviou Falhou!'
                newMessage.time = Math.floor(Date.now() / 1000)
                this.props.addMessage()
            }

            if (res.status == 400) {
                if (res.data == 'Session closed') {
                    await useNotification(
                        'Sessão encerrada!',
                        'Você não pode mais enviar mensagens para esta conversa',
                        'danger'
                    );
                } else if (res.data == 'Media type not allowed') {
                    await useNotification(
                        'Arquivo inválido!',
                        'Não é permitido o envio deste tipo de mídia',
                        'danger'
                    );
                } else if (res.data == 'Media size limit exceeded') {
                    await useNotification(
                        'Arquivo inválido!',
                        'O arquivo excedeu o limite máximo permitido',
                        'danger'
                    );
                } else if (res.data == 'Media extension not allowed') {
                    await useNotification(
                        'Arquivo inválido!',
                        'Não é pertimido o envio desta extensão de mídia',
                        'danger'
                    );
                } else if (res.data == 'Sandbox environment cannot exchange media') {
                    await useNotification(
                        'Sandbox!',
                        'Não é pertimido o envio de mídia em ambiente sandbox',
                        'danger'
                    );
                } else if (res.data == "Can't send document to Instagram") {
                    await useNotification(
                        'Ops!',
                        'Não é possível enviar documentos ao Instagram',
                        'danger'
                    );
                } else if (res.data == "Invalid url returned") {
                    await useNotification(
                        'Ops!',
                        'Erro ao recuperar URL',
                        'danger'
                    );
                }
                return;
            }

            if (res.status == 404) {
                await useNotification(
                    'Chat não encontrado!',
                    'Este chat foi finalizado pelo sistema',
                    'danger'
                );
                return;
            }

            if (res.status == 200) {

                Object.entries(res.data).map(([header, value]) => {
                    newMessage[header] = value
                })

                if (!this.isSupervised(this.props.activeChat.queue))
                    newMessage['message'] = newMessage['message']

                this.props.activeChat.socket?.send(JSON.stringify(
                    {
                        'channel': this.props.activeChat.channel,
                        'message': JSON.stringify(res.data),
                        'user': -2
                    }))

                this.props.addMessage()
                this.props.scrollDown()

                if (queue_name && connection && channel && 'chatstatus' in this.props.activeChat && this.props.activeChat.chatstatus == 'QUEUE')
                    connection.send(JSON.stringify({
                        message: "ONCHAT",
                        channel: channel
                    }))
            }
        } catch (err) {
            await useNotification(
                'Ops!',
                'Ocorreu um erro no sistema',
                'danger'
            );
            console.error(err);
        }
    }

    handleSubmit = async () => {
        if (this.props.activeChat.where === "finished") {
            await useNotification(
                "Atenção!",
                "Não é possível reativar um atendimento utilizando um arquivo ou imagem.",
                "warning"
            )
            return
        }

        if (this.props.isActiveChatOnQueue())
            await this.props.connectActiveChat();

        const files = this.props.files;
        this.props.clearFiles();

        for (const fileObj of files) {
            await this.sendSingleFile(fileObj);
        }
    }

    render() {
        const files = this.props.files;

        return (
            <Slide direction="up" in={files.length > 0} mountOnEnter unmountOnExit>
                <Box id="attachmentArea-box-1">
                    <Box id="attachmentArea-box-2">
                        {files.map((fileObj) => (
                            <Box key={fileObj.id} className="attachment-preview-item">
                                <IconButton size="small"
                                    className="attachment-preview-remove"
                                    onClick={() => this.props.removeFile(fileObj.id)}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                {fileObj.type === "image" &&
                                    <img src={fileObj.preview} />
                                }
                                {fileObj.type === "video" &&
                                    <iframe type="video/mp4/*" src={fileObj.preview} />
                                }
                                {fileObj.type === "document" &&
                                    <Box className='document-align-master'>
                                        <a target="_blank" href={fileObj.preview}>
                                            <InsertDriveFileIcon className="attachment-preview-doc-icon" />
                                        </a>
                                        <Typography align="center">
                                            {fileObj.name}
                                        </Typography>
                                    </Box>
                                }
                                {!this.isFileValid(fileObj) &&
                                    <Box textAlign="center" color="red" fontWeight="bold">
                                        Tamanho máximo de {MEDIA_SETTINGS[fileObj.type].translation}: {MEDIA_SETTINGS[fileObj.type].max_size}
                                    </Box>
                                }
                            </Box>
                        ))}
                        <input
                            accept="image/*,video/*,application/*"
                            style={{ display: 'none' }}
                            id="attachment-add-more-file"
                            multiple
                            type="file"
                            onChange={this.handleAddMore}
                        />
                        <label htmlFor="attachment-add-more-file" className="attachment-preview-add">
                            <Tooltip title="Adicionar outro arquivo" placement="top" disableInteractive>
                                <Fab color="primary" aria-label="Adicionar outro arquivo" size="small" component="span">
                                    <AddIcon />
                                </Fab>
                            </Tooltip>
                        </label>
                    </Box>
                    {this.hasWhatsappBlock() &&
                        <Box textAlign="center" color="red" fontWeight="bold">
                            Arquivos .xls não podem ser enviados pelo canal whatsapp, salve o arquivo como .xlsx e tente novamente.
                        </Box>}
                    <Box className={'preview-select-options'}>
                        <Button onClick={() => this.props.clearFiles()}>
                            Cancelar
                        </Button>
                        <Button className="send-attachment-btn"
                            variant="contained"
                            disabled={!this.canSubmit() || this.hasWhatsappBlock()}
                            onClick={() => this.handleSubmit()}
                        >
                            Enviar{files.length > 1 ? ` (${files.length})` : ''}
                        </Button>
                    </Box>
                </Box >
            </Slide >
        );
    }
}

export default AttachmentArea;
